import { render, staticRenderFns } from "./roleGroupInput.vue?vue&type=template&id=2a9163b2&"
import script from "./roleGroupInput.vue?vue&type=script&lang=js&"
export * from "./roleGroupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports